export default "__VITE_ASSET__D0SGnrsZ__"